<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

@if (!(addresses$ | async)?.length && emptyListLabel) {
  <profile-pds-p-text p-text color="contrast-medium">
    {{ emptyListLabel }}
  </profile-pds-p-text>
}

@if (addresses$ | async; as addresses) {
  @if (addresses.length) {
    <ul role="list" class="profile:mt-fluid-md profile:first:mt-0" [attr.aria-label]="'pidpaw.selectAddress.list.aria.mylanta' | translate">
      @for (address of addresses; track address) {
        <li class="profile:relative" [attr.data-default-address]="address.isStandard">
          @if ((addressIdBeingEdited$ | async) !== address.addressId) {
            <div class="profile:mt-fluid-md">
              <div class="profile:flex profile:pb-fluid-sm">
                @if (address.usage === 'work') {
                  <profile-pds-p-icon p-icon name="work" color="contrast-medium" size="xx-small" aria-hidden="true"></profile-pds-p-icon>
                }
                @if (address.usage === 'home') {
                  <profile-pds-p-icon p-icon name="home" color="contrast-medium" size="xx-small" aria-hidden="true"></profile-pds-p-icon>
                }
                <profile-pds-p-text p-text size="inherit" class="profile:text-[14px] profile:inline-block" color="contrast-medium"
                  >{{ getUsageString(address.usage ?? 'home') }} {{ getPrefixString(address.isStandard ?? false) }}</profile-pds-p-text
                >
              </div>
            </div>
            <div class="profile:flex profile:flex-col profile:md:flex-row profile:md:items-center profile:justify-between">
              <profile-pds-p-text class="fs-exclude" p-text data-protractor-id="address-widget-list-formatted-address-content">
                <span [innerHTML]="address.formattedAddress | pidxEscapeHtml | pidxNewLineTransform"></span>
              </profile-pds-p-text>
              <div>
                <profile-pds-p-button-pure
                  p-button-pure
                  icon="edit"
                  (click)="editItem(address)"
                  [disabled]="(listDisabled$ | async) ?? false"
                  data-protractor-id="address-widget-edit-address-button"
                  class="profile:inline-block profile:ms-0 profile:py-fluid-sm"
                  [aria]="{ 'aria-label': editButtonAriaLabel(address) }"
                  >{{ editItemLabel }}</profile-pds-p-button-pure
                >
              </div>
            </div>
          }
          @if ((addressIdBeingEdited$ | async) === address.addressId) {
            <div class="profile:w-full">
              <myprofile-address-editform
                [instanceId]="instanceId ?? ''"
                [token]="token"
                [cancelButtonLabel]="'pidpaw.editAddress.button.cancel.label' | translate"
                [saveButtonLabel]="'pidpaw.editAddress.button.save.label' | translate"
                [saveAndContinueButtonLabel]="'pidpaw.editAddress.button.saveAndContinue.label' | translate"
                [deleteButtonLabel]="'pidpaw.editAddress.button.delete.label' | translate"
              ></myprofile-address-editform>
            </div>
          }
        </li>
      }
    </ul>
  }
}
